import { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HamburgerMenu from './components/HamburgerMenu.jsx';
import Footer from './components/Footer.jsx';

const Home = lazy(() => import('./views/Home.jsx'));
const Post = lazy(() => import('./views/Post.jsx'));
const Category = lazy(() => import('./views/Category.jsx'));
const Tag = lazy(() => import('./views/Tag.jsx'));
const Search = lazy(() => import('./views/Search.jsx'));
const Countries = lazy(() => import('./views/Countries.jsx'));
const About = lazy(() => import('./views/About.jsx'));

const withSuspense = (LazyComponent) => (
  <Suspense fallback={null}>
    <LazyComponent />
  </Suspense>
);

function App() {
  return (
    <Router>
      <HamburgerMenu />
      <main className='container'>
        <Routes>
          <Route path="/" element={withSuspense(Home)} />
          <Route path="/post/:slug" element={withSuspense(Post)} />
          <Route path="/category/:slug" element={withSuspense(Category)} />
          <Route path="/tag/:slug" element={withSuspense(Tag)} />
          <Route path="/search" element={withSuspense(Search)} />
          <Route path="/countries" element={withSuspense(Countries)} />
          <Route path="/about" element={withSuspense(About)} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;